import { useState, useRef, useContext } from 'react';
import { useTranslations } from 'next-intl';
import {QRCodeCanvas} from 'qrcode.react';
import { StoreContext, namespace } from '@/context';
import CommonIcon from '../CommonIcon';
import {
  IShareModal
} from './mIndex';
import { PopoverCommonModal } from '../Popover';
import Toast from '../Toast';
import Clipboard from '../Clipboard/mIndex';
import { shareThread } from '@/api/detail';
import Styles from './index.module.scss';

const shareItems = [
  { key: 'copy-link', i18n: 'share_button_copy_link' },
  { key: 'weibo', i18n: 'btn_share_weibo' },
  { key: 'scan-code', i18n: 'btn_scan_code' },
];

const ShareModal = ({
  title,
  forumTypes,
  accountSlug,
  imgUrl,
  postTid,
  hidePopover,
  onShareHandler,
}: IShareModal) => {
  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS, extractThreadTags } = state[namespace.app].sensors || {};
  const t = useTranslations();
  let clipboardRef = useRef<any>();
  const [showQRCode, setShowQRCode] = useState(false);

  const handleShare = (key: string) => {
    const titleStr = !!title ? `《 ${title} 》` : '';
    const shareTitle = `我在#大疆社区#发现了一篇精彩内容${titleStr}，快来看看吧！`;
    const utmstr = '&pbc=dapcnbbs&utm_medium=djibbs&utm_source=djibbs&utm_campaign=shareweibo';
    if (key === 'copy-link') {
      const copyStr = window?.location?.href;
      (clipboardRef as any).initClipBoard(copyStr);
      // Toast.show({ content: t('tips_clipboard_paste_wx') });
      hidePopover?.(false);
      track?.(TRACK_EVENTS?.[namespace.detail].threadShareResult.name, {
        thread_name: title,
        thread_tid : postTid,
        thread_tag_name: extractThreadTags?.(forumTypes),
        account_slug: accountSlug,
        button_name: 'Copy',
      }, namespace.detail);
    } else if (key === 'weibo') {
      hidePopover?.(false);
      const shareUrl = "https://service.weibo.com/share/share.php?url="+ encodeURIComponent(window.location.href + utmstr)+"&pic=" + imgUrl + "&title=" + encodeURIComponent(shareTitle)+"&appkey=";
      track?.(TRACK_EVENTS?.[namespace.detail].threadShareResult.name, {
        thread_name: title,
        thread_tid : postTid,
        thread_tag_name: extractThreadTags?.(forumTypes),
        account_slug: accountSlug,
        button_name: 'Weibo',
      }, namespace.detail);
      window.open(shareUrl);
    } else if (key === 'scan-code') {
      hidePopover?.(true);
      setShowQRCode(true);
      track?.(TRACK_EVENTS?.[namespace.detail].threadShareResult.name, {
        thread_name: title,
        thread_tid : postTid,
        thread_tag_name: extractThreadTags?.(forumTypes),
        account_slug: accountSlug,
        button_name: 'Mobile',
      }, namespace.detail);
    }
    onShareHandler?.();
    shareThread({ tid: postTid });
  };

  return (
    <PopoverCommonModal className={Styles.modalRoot}>
      <>
        <Clipboard
          ref={(ele: any) => {
            clipboardRef = ele;
          }}
        />
        <ul className={Styles.list}>
          {
            shareItems.map(({ key, i18n }: { key: string, i18n: string }) => (
              <li key={key} className={Styles.shareItem} onClick={() => handleShare(key)} >
                <CommonIcon className={Styles.icon} icon={key} />
                <div className={Styles.label}>{t(i18n)}</div>
              </li>
            ))
          }
          {
            showQRCode && (
              <div className={Styles.codeWrapper}>
                <div className={Styles.code}>
                  <QRCodeCanvas value={window.location.href} size={116} />
                </div>
                <span className={Styles.tipText}>{t('btn_scan_code_tip')}</span>
              </div>
            )
          }
        </ul>
      </>
    </PopoverCommonModal>
  )
}

export default ShareModal;
